<template>
  <PersonalPage />
</template>

<script>
import PersonalPage from "./components/PersonalPage.vue";

export default {
  name: "App",
  components: {
    PersonalPage,
  },
};
</script>